var timeCost = 10;
var milageCostUSD = 0.25;
var milageCostCAD = 0.12;
var maxSkaterCount = 5;
var defaultInseasonMonths = 7;
var recommendedSessionsBtwSharpenings = 2;
//var noOfSharpeningsPerRing = 320 / 6;
var noOfSharpeningsPerRing = 60;
var timeTosharpenSkates = 5;//min
var minSharpeningTimePerSkate = 6;
var conversionFactor = 1.3;//convertion USD $ to CAD $
var desiredNoOfSharpenings = 4;//insted of taking input from user, we are making it as a constant value

var sparx_emailID = "ryan@sparxhockey.com";// EmailID to which we need to send the three screen shots when user hit on calculate button


// sparx images base64
var sparxLogoCompleteWhiteSrc = "data:image/svg+xml;base64,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";


var lastEditedDivId = 0;
var skaterInfoObj;
var editFlag = false;
var considerTimeAsCost;//true/false/isTimeAsCost
var editId = 0;


var country;
var totalSkaterCount = 0;
var currentSkaterCount = 0;
var sharpingTime = 0;
var milageCost = 0;
var yearsLeftToPlay = 0;
var skaterBasicInfo = new Object();
var skaterDetailsArr = new Array();
var previousSkateDetails;



var totalSharpeningsCount = 0;
var totalMilesTravelled = 0;
var totalTravellingTime = 0;
var totalWaitingTime = 0;
var adjusteddistance = 0;
var adjustedTravellingTime = 0;
var adjustedWaitingTime = 0;


//Flags
var emailFlag = true;


//Final Analysis
var totalSkatingSessionsAttended = 0;
var skaternames;
var userInputString = null;


var withOutSparxCostDetails = new Object();
withOutSparxCostDetails.totalSharpeningsCountCurrent = 0;
withOutSparxCostDetails.totalMilesDrivenCurrent = 0;
withOutSparxCostDetails.totalWaitingTimeCurrent = 0;
withOutSparxCostDetails.annualSharpeningCostCurrent = 0;

withOutSparxCostDetails.totalSharpeningsCountDesired = 0;
withOutSparxCostDetails.totalMilesDrivenDesired = 0;
withOutSparxCostDetails.totalWaitingTimeDesired = 0;
withOutSparxCostDetails.annualSharpeningCostDesired = 0;

withOutSparxCostDetails.totalSharpeningsCountRecommended = 0;
withOutSparxCostDetails.totalMilesDrivenRecommended = 0;
withOutSparxCostDetails.totalWaitingTimeRecommended = 0;
withOutSparxCostDetails.annualSharpeningCostRecommended = 0;


var withSparxCostDetails = new Object();
withSparxCostDetails.totalSharpeningsCountCurrent = 0;
withSparxCostDetails.totalGrindingRingsCurrent = 0;
withSparxCostDetails.totalSharpeningTimeCurrent = 0;
withSparxCostDetails.annualSharpeningCostCurrent = 0;

withSparxCostDetails.totalSharpeningsCountDesired = 0;
withSparxCostDetails.totalGrindingRingsDesired = 0;
withSparxCostDetails.totalSharpeningTimeDesired = 0;
withSparxCostDetails.annualSharpeningCostDesired = 0;

withSparxCostDetails.totalSharpeningsCountAnticipated = 0;
withSparxCostDetails.totalGrindingRingsAnticipated = 0;
withSparxCostDetails.totalSharpeningTimeAnticipated = 0;
withSparxCostDetails.annualSharpeningCostAnticipated = 0;

var primaryInfoImage, skaterinfoImage, finalReportImage, completeImage;

function skaterDetails(name, inSeason, offSeason, actualHrs, desiredHrs) {
    this.name = name;
    this.inSeasonSessionsPerWeek = inSeason;
    this.offSeasonSessionsPerWeek = offSeason;
    this.actualSkatingHrs = actualHrs;
    this.desiredSkatingHrs = desiredHrs;
    this.inSeasonSessionsPerMonth = (52 / 12) * this.inSeasonSessionsPerWeek;
    this.offSeasonSessionsPerMonth = (52 / 12) * this.offSeasonSessionsPerWeek;
    this.avgSessionsPerMonth = ((defaultInseasonMonths * this.inSeasonSessionsPerMonth) + ((12 - defaultInseasonMonths) * this.offSeasonSessionsPerMonth)) / 12;
    this.currentSharpenings = Math.round(this.avgSessionsPerMonth * 12 / this.actualSkatingHrs);
    this.desiredSharpenings = Math.round(this.avgSessionsPerMonth * 12 / this.desiredSkatingHrs);
    this.recommendedSharpenings = Math.round(this.avgSessionsPerMonth * 12 / recommendedSessionsBtwSharpenings);
};

//email sending
function primaryInfoValidat() {
    console.log("In validation");
    var dist = document.getElementById("distance").value;
    var tt = document.getElementById('traveltime').value;
    var wt = document.getElementById('waitingtime').value;
    var scost = document.getElementById('sharpeningcost').value;
    var years = document.getElementById('yearsleft').value;
    var tc = document.getElementById('timecost').value;//not always

    if (parseInt(dist) >= 0 && parseInt(tt) >= 0 && parseInt(wt) >= 0 && parseInt(scost) >= 0 && years != undefined && country != undefined && totalSkaterCount > 0 && sharpingTime >= 0 && years >= 1) {
        if ((totalSkaterCount === 1 || (totalSkaterCount > 1 && $("input[name='tripdetails']:checked").val() != undefined)) && (considerTimeAsCost || (!considerTimeAsCost && tc != ""))) {

            //console.log("time cost " + tc);
            $('#continue').prop("disabled", false);
            $('#continue').css("background-color", "#f7403a");
        }
        else {
            //console.log("time cost 10");
            $('#continue').prop("disabled", true);
            $('#continue').css("background-color", "grey");
        }
    }
    else {
        $('#continue').prop("disabled", true);
        $('#continue').css("background-color", "grey");
    }

};

function skaterInfoValidat(skaterNumber) {

    //Initally disable next and cal buttons by default
      $(calID + ' .calbutton').prop("disabled", true);
      $(navId + " #" + skaterNumber).prop("disabled", true);


    var sname = document.getElementById("skatername" + skaterNumber).value;
    var inSeason = document.getElementById('inseasonhrs' + skaterNumber).value;
    var offSeason = document.getElementById('offseasonhrs' + skaterNumber).value;
    var current = document.getElementById('currentsharpeninghrs' + skaterNumber).value;
    var desired = desiredNoOfSharpenings

    var navId = '#navigationdiv' + skaterNumber;
    var calID = '#calculatediv' + skaterNumber;

    if (sname != undefined && sname != "" && inSeason != "" && inSeason >= 0 && offSeason != "" && offSeason >= 0 && current > 0 && desired > 0) {


        $(calID + ' .calbutton').prop("disabled", false);
        $(navId + " #" + skaterNumber).prop("disabled", false);
        $(calID + ' .calbutton').css("background-color", "#f7403a");
        $(navId + " #" + skaterNumber).css("background-color", "#f7403a");

    }
    else {
        $(calID + ' .calbutton').prop("disabled", true);
        $(navId + " #" + skaterNumber).prop("disabled", true);
        $(calID + ' .calbutton').css("background-color", "grey");
        $(navId + " #" + skaterNumber).css("background-color", "grey");
    }

};

function emailValidation() {
    var email = document.getElementById("email").value;
    var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;

    //console.log("regex test "+regex.test(email));
    if (regex.test(email)) {
        $('#submitEmail').prop("disabled", false);
        $('#submitEmail').css("background-color", "#f7403a");
    }
    else {
        $('#submitEmail').prop("disabled", true);
        $('#submitEmail').css("background-color", "grey");
    }
}

function printResult() {
    window.print();
    $('.change_print_logo').attr("src", "https://cdn.shopify.com/s/files/1/0932/7770/files/sparxlogo-complete-white.svg?7653690076447067639");
}

function printGraphResult() {

    $('.change_print_logo').attr("src", "https://cdn.shopify.com/s/files/1/0932/7770/t/16/assets/logo.svg?17814707386207788635");

    setTimeout(function () {
        printResult();
    }, 100);


    return true;
};

function setLeftNavHeight(newHeight) {

    $('#mySidenav').css("height", newHeight);
}

function ShopInfoValidat() {
    var sharpeningCost = document.getElementById('shop-sharpeningcost').value;
    var noOfsharpenings = document.getElementById('current-sharpenings-count').value;
    var hourlyWage = document.getElementById('current-hourly-wage').value;
    var sparx_hourlyWage = document.getElementById('non-expert-wage').value;
    var percentage = document.getElementById('percentage-increase').value;
    var equipmentCost = document.getElementById('equipment-cost').value;//only wehn yes
    var years = document.getElementById('analysis-years').value;


    if (parseInt(sharpeningCost) >= 0 && parseInt(noOfsharpenings) >= 0 && parseInt(hourlyWage) >= 0 && parseInt(sparx_hourlyWage) >= 0 && country != undefined && parseInt(percentage) >= 0 && years >= 1 && $("input[name='consider-equipment-cost']:checked").val() != undefined) {
        if ($("input[name='consider-equipment-cost']:checked").val() == 'no' || ($("input[name='consider-equipment-cost']:checked").val() == 'yes' && parseInt(equipmentCost) > 0)) {


            $('#continue_commercial').prop("disabled", false);
            $('#continue_commercial').css("background-color", "#f7403a");
        }
        else {

            $('#continue_commercial').prop("disabled", true);
            $('#continue_commercial').css("background-color", "grey");
        }
    }
    else {

        $('#continue_commercial').prop("disabled", true);
        $('#continue_commercial').css("background-color", "grey");
    }
}

$(document).ready(function () {

    var sharpenerUnitCost = parseFloat(document.getElementById("sharpenerUnitCostHelper").value);//in dollers ($)
    var grindingWheelCost = parseFloat(document.getElementById("grindingWheelCostHelper").value);//in dollers ($)

    google.charts.load('current', { packages: ['corechart', 'line', 'imagechart'] });

    setLeftNavHeight($('.calculator-main').height());

    $('#maindiv').on('focus', 'input[type=number]', function (e) {
        $(this).on('mousewheel.disableScroll', function (e) {
            e.preventDefault();
        });
    });

  	$('.change_print_logo').attr("src", sparxLogoCompleteWhiteSrc);

    $('.calDetailsLink').click(function () {
        var source = $("#calDetailsdiv").html();
        var mywindow = window.open('', 'Document', 'height=1000,width=1000');
        mywindow.document.write('<!DOCTYPE html><html><head><link href="http://cdn.shopify.com/s/files/1/0932/7770/t/16/assets/calculator.css?15187272190075492169" rel="stylesheet" type="text/css" media="all" />');
        mywindow.document.write("</head><body>");
        mywindow.document.write(source);
        mywindow.document.write('</body></html>');
        mywindow.focus();

        return true;
    });

    $('#step1').css("color", "white");

    $("div.set1").find("input[type='button']").click(function () {

        $(".set1").find("input[type='button']").removeClass("active");
        $(".set1").find("input[type='button']").css("background-color", "#efefef");
        $(".set1").find("input[type='button']").css("color", "rgba(0, 0, 0, 0.5)");
        $(".set1").find("input[type='button']").css("border", "solid 0.5px #aaaaaa");

        $(this).css("background-color", "rgb(247, 64, 58)");
        $(this).css("color", "#fff");
        $(this).css("border", "solid 0.5px #ab0101");
        $(this).addClass("active");


        totalSkaterCount = parseInt($(this).val());
        if (totalSkaterCount > 1) {
            $('#otherSkaters').css("display", "block");
            $('#timecostdiv').css("border-bottom", "1px solid #dbdbdb");
        }
        else {
            $('#otherSkaters').css("display", "none");
            $('#timecostdiv').css("border-bottom", "0");
        }


        if (totalSkaterCount < skaterDetailsArr.length) {
            skaterDetailsArr = skaterDetailsArr.splice(0, totalSkaterCount);
        }
        console.log(skaterDetailsArr);
        primaryInfoValidat();
        setLeftNavHeight($('.calculator-main').height());
    });

    $("div.set2").find("input[type='button']").click(function () {


        $(".set2").find("input[type='button']").removeClass("active");
        $(".set2").find("input[type='button']").css("background-color", "#efefef");
        $(".set2").find("input[type='button']").css("color", "rgba(0, 0, 0, 0.5)");
        $(".set2").find("input[type='button']").css("border", "solid 0.5px #aaaaaa");

        $(this).css("background-color", "rgb(247, 64, 58)");
        $(this).css("color", "#fff");
        $(this).css("border", "solid 0.5px #ab0101");
        $(this).addClass("active");

        sharpingTime = parseInt($(this).val().slice(0, -1));//.slice(0,-1)



        primaryInfoValidat();
    });

    $("div.countrybtn").find("input[type='button']").click(function () {


        $(".countrybtn").find("input[type='button']").css("background-color", "#efefef");
        $(".countrybtn").find("input[type='button']").css("color", "rgba(0, 0, 0, 0.5)");
        $(".countrybtn").find("input[type='button']").css("border", "solid 0.5px #aaaaaa");

        countryButtonClicked(this);
        //console.log(country);
        primaryInfoValidat();
    });

    function countryButtonClicked(buttonObj) {

        $(buttonObj).css("background-color", "rgb(247, 64, 58)");
        $(buttonObj).css("color", "#fff");
        $(buttonObj).css("border", "solid 0.5px #ab0101");

        country = $(buttonObj).val();

        if (country === "CANADA") {
            //console.log('In can');
            $('#kms').prop("checked", true);
            $('#cad').prop("checked", true);

            $('#kms').prop("disabled", false);
            $('#cad').prop("disabled", false);
            $('#mile').prop("disabled", true);
            $('#usd').prop("disabled", true);
        }
        else {
            $('#mile').prop("checked", true);
            $('#usd').prop("checked", true);

            $('#mile').prop("disabled", false);
            $('#usd').prop("disabled", false);
            $('#kms').prop("disabled", true);
            $('#cad').prop("disabled", true);
        }
    }

    $('#item1,#brdcrb1').click(function () {
        if (!$('#step1').prop("disabled")) {
            $('#primaryInfo,#skater-shop-info').css("display", "block");
            $('#skaterinfo,#paybackCalculation').css("display", "none");
            $('#item2,#item3').css("cursor", "auto");
            $('#step2,#step3').prop("disabled", true);

            $('#houseimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/Home-current.png?8630967100296663801');
            $('#skaterimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/skate-inactive.png?8595424180133040691');
            $('#calculateimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/payback-inactive.png?8595424180133040691');

            $('#step1').removeClass('leftPanelBtns').addClass('arrow_box');
            $('#step2').removeClass('arrow_box').addClass('leftPanelBtns');
            $('#step3').removeClass('arrow_box').addClass('leftPanelBtns');

            $('#step1').css("color", "#fff");
            $('#step2,#step3').css("color", "#aaa");

            $('#brdcrb1').addClass('breadcrumb-active');
            $('#brdcrb2,#brdcrb3').removeClass('breadcrumb-active');
            $('#brdcrb2,#brdcrb3').css("color", "#aaaaaa");
            $('#brdcrb2,#brdcrb3').css("cursor", "default");

            setLeftNavHeight($('.calculator-main').height());

            //display manipulation for benefits details
            $(".benefits-details").css("display", "none");
            $(window).scroll(function () {
              if($(".header-calculator").offset() != null && $(".featured-lead").offset() != undefined){
              console.log($(".header-calculator").offset());
                if (($(window).scrollTop() > $(".header-calculator").offset().top + 280) && ($(window).scrollTop() <= $(".featured-lead").offset().top) + 10) {
                    $(".breadcrumb").css("position", "fixed");
                    $(".breadcrumb").css("top", "0");
                }

                if ($(window).scrollTop() <= $(".header-calculator").offset().top + 280) {
                    $(".breadcrumb").css("position", "relative");
                }

                if ($(window).scrollTop() > $(".featured-lead").offset().top + 20) {
                    $(".breadcrumb").css("position", "relative");
                    $(".breadcrumb").css("top", $(".featured-lead").offset().top - $(".header-calculator").offset().top - 350);
                }

                if (($(window).scrollTop() > $("#mySidenav").offset().top - 100) && ($(window).scrollTop() <= $(".featured-lead").offset().top - 534.859375)) {
                    $(".left-nav").css("position", "fixed");
                    $(".left-nav").css("top", "134.859375px");
                    $(".left-nav").addClass("left-navwhenfix");
                }

                if ($(window).scrollTop() <= $("#mySidenav").offset().top - 100) {
                    $(".left-nav").css("position", "static");
                    $(".left-nav").removeClass("left-navwhenfix");
                }

                if ($(window).scrollTop() > $(".featured-lead").offset().top - 634.859375) {
                    $(".left-nav").css("position", "relative");
                    $(".left-nav").css("top", $(".featured-lead").offset().top - 934.859375);
                    $(".left-nav").removeClass("left-navwhenfix");
                }
             }

            });
            //end
        }
    });

    $('#item2,#brdcrb2').click(function () {
        if (!$('#step2').prop("disabled")) {
            $('#skaterinfo').css("display", "block");
            $('#item1').css("cursor", "pointer");
            $('#primaryInfo,#paybackCalculation').css("display", "none");
            $('#step3').prop("disabled", true);


            $('#skaterimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/skate-current.png?8630967100296663801');
            $('#calculateimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/payback-inactive.png?8595424180133040691');

            $('#step2').removeClass('leftPanelBtns').addClass('arrow_box');
            $('#step3').removeClass('arrow_box').addClass('leftPanelBtns');

            $('#step2').css("color", "#fff");
            $('#step1').css("color", "grey");
            $('#step3').css("color", "#aaa");

            $('#brdcrb2').addClass('breadcrumb-active');
            $('#brdcrb1,#brdcrb3').removeClass('breadcrumb-active');
            $('#brdcrb1').css("color", "#ffffff");
            $('#brdcrb1').css("cursor", "pointer");
            $('#brdcrb3').css("color", "#aaaaaa");

            //By default open first skaterInfo
            $('#content1').css("display", "block");
            skaterInfoValidat(1);//validate first div

            setLeftNavHeight($('.calculator-main').height());
        }
    });

    $('#item3,#brdcrb3').click(function () {
        if (!$('#step3').prop("disabled")) {
            $('#item1,#item2,#item3').css("cursor", "pointer");
            $('#paybackCalculation,#benefits-details').css("display", "block");
            $('#skaterinfo,#primaryInfo,#skater-shop-info').css("display", "none");

            $('#calculateimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/payback-current.png?8630967100296663801');

            $('#step3').css("color", "#fff");
            $('#step1 ,#step2').css("color", "grey");

            $('#brdcrb3').addClass('breadcrumb-active');
            $('#brdcrb2,#brdcrb1').removeClass('breadcrumb-active');
            $('#brdcrb1,#brdcrb2').css("color", "#ffffff");
            $('#brdcrb1,#brdcrb2').css("cursor", "pointer");

            setLeftNavHeight($('.calculator-main').height());
        }
    });

    $('#continue').click(function () {

        yearsLeftToPlay = parseInt($('#yearsleft').val());
        skaterBasicInfo.sharpenerShopDist = parseInt($('#distance').val());
        skaterBasicInfo.travelTime = parseInt($('#traveltime').val());
        skaterBasicInfo.distMeasuredIn = $("input[name='distIn']:checked").val();
        skaterBasicInfo.waitingTime = parseInt($('#waitingtime').val());
        skaterBasicInfo.costInCurrency = $("input[name='currency']:checked").val();
        skaterBasicInfo.totalSkaterCount = totalSkaterCount;
        skaterBasicInfo.sharpeningTime = sharpingTime;
        skaterBasicInfo.country = country;
      	skaterBasicInfo.email=$("#email").val();
        skaterBasicInfo.yearsLeftToPlay = parseInt($('#yearsleft').val());
        skaterBasicInfo.sharpeningCost = parseInt($('#sharpeningcost').val());
        skaterBasicInfo.considerTimeAsCost = $("input[name='considertimeascost']:checked").val();
        skaterBasicInfo.timeCost = (considerTimeAsCost ? ($('input[name="currency"]:checked').val() == 'CAD' ? 13 : 10) : parseInt($("#timecost").val()));
        skaterBasicInfo.sharpingTripDetails = ($("input[name='tripdetails']:checked").val() == undefined) ? "same" : $("input[name='tripdetails']:checked").val();

//  skaterBasicInfo object validation
      if(!isNaN(skaterBasicInfo.sharpenerShopDist) && !isNaN(skaterBasicInfo.yearsLeftToPlay) && !isNaN(skaterBasicInfo.travelTime) && !isNaN(skaterBasicInfo.waitingTime) && !isNaN(skaterBasicInfo.sharpeningCost)){

        convertDivToImage("primaryInfo");

        var inverseValue = (1 - (sharpingTime / 100));

        adjusteddistance = skaterBasicInfo.sharpenerShopDist * inverseValue;
        adjustedTravellingTime = skaterBasicInfo.travelTime * inverseValue;
        adjustedWaitingTime = (skaterBasicInfo.waitingTime * inverseValue) + (totalSkaterCount * (sharpingTime / 100) * minSharpeningTimePerSkate);

        if (skaterBasicInfo.country === "CANADA") {
            milageCost = milageCostCAD;
            sharpenerUnitCost = Math.round(sharpenerUnitCost * conversionFactor);
            grindingWheelCost = Math.round(grindingWheelCost * conversionFactor);
            skaterBasicInfo.timeCost = Math.round(skaterBasicInfo.timeCost * conversionFactor);

        }
        else {
            milageCost = milageCostUSD;
        }


        $('#primaryInfo').css("display", "none");
        $('#skaterinfo').css("display", "block");
        $('#step2').prop("disabled", false);


        $('#item2').css("cursor", "pointer");

        $('#houseimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/completed.png?8630967100296663801');
        $('#step1').removeClass('arrow_box').addClass('leftPanelBtns');

        $('#skaterimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/skate-current.png?8595424180133040691');
        $('#step2').removeClass('leftPanelBtns').addClass('arrow_box');

        $('#step2').css("color", "#fff");
        $('#step1').css("color", "grey");

        $('#brdcrb1').removeClass('breadcrumb-active');
        $('#brdcrb2').addClass('breadcrumb-active');
        $('#brdcrb1').css("cursor", "pointer");

        //always display first skater info coming to 2nd screen
        $('#content1').css("display", "block");
        //$('#content' + lastEditedDivId).css("display", "none");

        for (currentSkaterCount = 1; currentSkaterCount <= totalSkaterCount; currentSkaterCount++) {
            var title = "Skater " + currentSkaterCount + " of " + totalSkaterCount;
            //console.log(title);
            $('#skatertitle' + currentSkaterCount).text(title);
            $('#skaterinfo' + currentSkaterCount).css("display", "block");

            $('#content' + currentSkaterCount).css("display", "none");
            if (currentSkaterCount === 1) {
                $('#content' + currentSkaterCount).css("display", "block");
                if (skaterDetailsArr.length >= 1) {
                    $('#skatername1').val(skaterDetailsArr[0].name);
                    $('#inseasonhrs1').val(skaterDetailsArr[0].inSeasonSessionsPerWeek);
                    $('#offseasonhrs1').val(skaterDetailsArr[0].offSeasonSessionsPerWeek);
                    $('#currentsharpeninghrs1').val(skaterDetailsArr[0].actualSkatingHrs);
                    $('#desiredsharpeninghrs1').val(skaterDetailsArr[0].desiredSkatingHrs);
                    skaterInfoValidat(1);
                }
                //skaterInfoValidat(1);
            }

            if (currentSkaterCount === totalSkaterCount) {
                //console.log(currentSkaterCount);
                $('#navigationdiv' + currentSkaterCount).css("display", "none");
                $('#calculatediv' + currentSkaterCount).css("display", "block");
            }
            else {
                $('#navigationdiv' + currentSkaterCount).css("display", "block");
                $('#calculatediv' + currentSkaterCount).css("display", "none");
            }
        }
        for (currentSkaterCount ; currentSkaterCount <= 5; currentSkaterCount++) {
            $('#skaterinfo' + currentSkaterCount).css("display", "none");
        }

          var mainCalcSection = document.querySelector('.calculator-main');
          mainCalcSection.scrollIntoView({ behavior: 'smooth' });
        setLeftNavHeight($('.calculator-main').height());
        nextId = 0;
      }
      else{
      	primaryInfoValidat();
      }
    });

    var nextId = 0;
    $('.nextSkater').click(function () {
        lastEditedDivId = parseInt($(this).attr("id"));
        //console.log(lastEditedDivId);
        nextId = lastEditedDivId + 1;
        editFlag = false;

        $('#skaternametext' + lastEditedDivId).text($('#skatername' + lastEditedDivId).val());
        skaterInfoObj = new skaterDetails($('#skatername' + lastEditedDivId).val(), parseInt($('#inseasonhrs' + lastEditedDivId).val()), parseInt($('#offseasonhrs' + lastEditedDivId).val()), parseInt($('#currentsharpeninghrs' + lastEditedDivId).val()), desiredNoOfSharpenings);

        console.log(lastEditedDivId);
        if (lastEditedDivId > skaterDetailsArr.length) {
            console.log("push");
            skaterDetailsArr.push(skaterInfoObj);
        }
        else {
            skaterDetailsArr[lastEditedDivId - 1] = skaterInfoObj;
        }

        $('#copyinfocheckbox' + lastEditedDivId).css("display", "none");
        $('#content' + lastEditedDivId).css("display", "none");
        $('#editskater' + lastEditedDivId).css("display", "block");


        $('#copyinfocheckbox' + nextId).css("display", "block");
        $('#content' + nextId).css("display", "block");

        if (skaterDetailsArr.length >= nextId) {
            $('#skatername' + nextId).val(skaterDetailsArr[nextId - 1].name);
            $('#inseasonhrs' + nextId).val(skaterDetailsArr[nextId - 1].inSeasonSessionsPerWeek);
            $('#offseasonhrs' + nextId).val(skaterDetailsArr[nextId - 1].offSeasonSessionsPerWeek);
            $('#currentsharpeninghrs' + nextId).val(skaterDetailsArr[nextId - 1].actualSkatingHrs);
        }

        $('#skaterinfo' + nextId).scrollTop(0);

        if (nextId === totalSkaterCount) {
            console.log(nextId);
            $('#navigationdiv' + nextId).css("display", "none");
            $('#calculatediv' + nextId).css("display", "block");
        }

        if ($('.copyPreviousInfo').prop("checked") == false) {
            clearSkaterDiv(lastEditedDivId);
        }
        currentSkaterCount++;
        skaterInfoValidat(nextId);
        setLeftNavHeight($('.calculator-main').height());
    });


    $('.edit').click(function () {

        editId = parseInt($(this).attr("id"));
        hideAllContentDivs();
        $('#content' + editId).css("display", "block");
        $('#copyinfocheckbox' + editId).css("display", "block");

        $('#skaternametext' + nextId).text($('#skatername' + nextId).val());
        $('#editskater' + nextId).css("display", "block");


        var id = lastEditedDivId;
        if (!editFlag) {
            id = nextId;
        }
        //update previous skater details
        skaterInfoObj = new skaterDetails($('#skatername' + id).val(), parseInt($('#inseasonhrs' + id).val()), parseInt($('#offseasonhrs' + id).val()), parseInt($('#currentsharpeninghrs' + id).val()), desiredNoOfSharpenings);
        console.log(nextId);
        if (nextId > 0) {
            if (nextId > skaterDetailsArr.length) {
                skaterDetailsArr.push(skaterInfoObj);
            }
            else {
                skaterDetailsArr[id - 1] = skaterInfoObj;
            }
        }
        lastEditedDivId = editId;

        if (editFlag) {
            nextId = editId;
        }
        editFlag = true;


        $('#skatername' + editId).val(skaterDetailsArr[editId - 1].name);
        $('#inseasonhrs' + editId).val(skaterDetailsArr[editId - 1].inSeasonSessionsPerWeek);
        $('#offseasonhrs' + editId).val(skaterDetailsArr[editId - 1].offSeasonSessionsPerWeek);
        $('#currentsharpeninghrs' + editId).val(skaterDetailsArr[editId - 1].actualSkatingHrs);

        skaterInfoValidat(editId);

        setLeftNavHeight($('.calculator-main').height());

    });

    function hideAllContentDivs() {
        for (var i = 1; i <= totalSkaterCount; i++) {
            $('#content' + i).css("display", "none");

            $('#copyinfocheckbox' + i).css("display", "none");
        }
    }

    function showAllContentDivs() {
        console.log(skaterDetailsArr);
        for (var i = 1; i <= totalSkaterCount; i++) {
            $('#content' + i).css("display", "block");
            $('#copyinfocheckbox' + i).css("display", "block");
            $('#skatername' + i).val(skaterDetailsArr[i - 1].name);
            $('#inseasonhrs' + i).val(skaterDetailsArr[i - 1].inSeasonSessionsPerWeek);
            $('#offseasonhrs' + i).val(skaterDetailsArr[i - 1].offSeasonSessionsPerWeek);
            $('#currentsharpeninghrs' + i).val(skaterDetailsArr[i - 1].actualSkatingHrs);
        }
    }

    function copyPrevious() {

        var previousSkateDetails = skaterInfoObj
        //console.log(lastEditedDivId);
        for (i = lastEditedDivId + 1; i <= totalSkaterCount; i++) {
            $('#skatername' + i).val("skater" + i);
            $('#inseasonhrs' + i).val(previousSkateDetails.inSeasonSessionsPerWeek);
            $('#offseasonhrs' + i).val(previousSkateDetails.offSeasonSessionsPerWeek);
            $('#currentsharpeninghrs' + i).val(previousSkateDetails.actualSkatingHrs);

            $('#copyinfo' + i).prop("checked", true);
            skaterInfoValidat(i);
        }
    }

    function clearSkaterDiv(id) {
        $('#skatername' + id).val("");
        $('#inseasonhrs' + id).val("");
        $('#offseasonhrs' + id).val("");
        $('#currentsharpeninghrs' + id).val("");
        $('#copyinfo' + id).prop("checked", false);
        skaterInfoValidat(id);
    }

    $('.copyPreviousInfo').change(function () {
        if ($(this).is(":checked")) {
            copyPrevious();
        }
        else {
            clearSkaterDiv(($(this).attr('id')).substr($(this).attr('id').length - 1));
        }
    });


    $('input[type=radio][name=considertimeascost]').change(function () {
        if (this.value == 'yes') {
            $('#timecostinfodiv').css("display", "none");
            skaterBasicInfo.timeCost = timeCost;
            considerTimeAsCost = true;
        }
        else if (this.value == 'no') {
            $('#timecostinfodiv').css("display", "block");
            considerTimeAsCost = false;
        }
        primaryInfoValidat();
        setLeftNavHeight($('.calculator-main').height());
    });

    $('.calbutton').click(function () {

        if (totalSkaterCount >= skaterDetailsArr.length) {
            $('#skaternametext' + totalSkaterCount).text($('#skatername' + totalSkaterCount).val());
            $('#editskater' + totalSkaterCount).css("display", "block");
            skaterInfoObj = new skaterDetails($('#skatername' + totalSkaterCount).val(), parseInt($('#inseasonhrs' + totalSkaterCount).val()), parseInt($('#offseasonhrs' + totalSkaterCount).val()), parseInt($('#currentsharpeninghrs' + totalSkaterCount).val()), desiredNoOfSharpenings);

            //skaterDetailsArr.push(skaterInfoObj);
            skaterDetailsArr[totalSkaterCount -1]=skaterInfoObj;
        }



      function skaterInfoApproval(){
      	var approvalTicket = true;
        var count=0;
        while(count<skaterDetailsArr.length && approvalTicket){
          if(skaterDetailsArr[count].name == "" || isNaN(skaterDetailsArr[count].inSeasonSessionsPerWeek) || isNaN(skaterDetailsArr[count].offSeasonSessionsPerWeek) || isNaN(skaterDetailsArr[count].actualSkatingHrs)){
          	approvalTicket = false;
          }
          count++;
        }
        return approvalTicket;
      }


      if(skaterInfoApproval()){
        skaterInfoValidat(totalSkaterCount);
        showAllContentDivs();
        convertDivToImage("skaterinfo");
        hideAllContentDivs();

        $('#skaterimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/completed.png?8630967100296663801');
        $('#step2').removeClass('arrow_box').addClass('leftPanelBtns');

        $('#step2').css("color", "grey");
        $('#step3').css("color", "#fff");
        $('#item3').css("cursor", "pointer");
        $('#calculateimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/payback-current.png?8630967100296663801');
        $('#step3').removeClass('leftPanelBtns').addClass('arrow_box');


        $('#brdcrb2').removeClass('breadcrumb-active');
        $('#brdcrb3').addClass('breadcrumb-active');
        $('#brdcrb2').css("cursor", "pointer");

        CombineAllSkaterCost();
        initalizeWithSparxCostDetails();


        var x_interceptSumCurrentWithSparx = 0;
        var x_interceptSumDesiredWithSparx = 0;

        var x_interceptSumCurrentWithOutSparx = 0;
        var x_interceptSumDesiredWithOutSparx = 0;


        showReportData();
        GetUserInputString();

        $('#skaterinfo').css("display", "none");
        $('#paybackCalculation').css("display", "block");
        drawTrendlines();
        $('#step3').prop("disabled", false);

          var mainCalcSection = document.querySelector('.calculator-main');
          mainCalcSection.scrollIntoView({ behavior: 'smooth' });

        setLeftNavHeight($('.calculator-main').height());
        emailFlag = true;

//         convertDivToImage("paybackCalculation");
      }
      else{
      	skaterInfoValidat(totalSkaterCount);
      }

      UpdateDataToHubSpotForm();
    });


    function UpdateDataToHubSpotForm(){

    //$("input[name=firstname]").val(skaterDetailsArr[0].name);

    $('input[name=country]').val(skaterBasicInfo.country);
    $('input[name=email]').val(skaterBasicInfo.email);
    $('input[name=sharpenershopdist]').val(skaterBasicInfo.sharpenerShopDist+" "+skaterBasicInfo.distMeasuredIn);
    $('input[name=traveltime]').val(skaterBasicInfo.travelTime +" Minutes");
    $('input[name=waitingtime]').val(skaterBasicInfo.waitingTime +" Minutes");
    $('input[name=sharpeningcost]').val(skaterBasicInfo.sharpeningCost+" "+skaterBasicInfo.costInCurrency);
    $('input[name=totalskatercount]').val(skaterBasicInfo.totalSkaterCount);
    $('input[name=sharpeningtime]').val(skaterBasicInfo.sharpeningTime + "%");
    $('input[name=yearslefttoplay]').val(skaterBasicInfo.yearsLeftToPlay +" Years");
    $('input[name=considertimeascost]').val(skaterBasicInfo.considerTimeAsCost);
    $('input[name=timecost]').val(skaterBasicInfo.timeCost +" "+skaterBasicInfo.costInCurrency);

    for(var i = 1; i<= totalSkaterCount;i++){
      $("input[name=skater"+i+"_name]").val(skaterDetailsArr[i-1].name);
      $("input[name=skater"+i+"_inseasonsessionsperweek]").val(skaterDetailsArr[i-1].inSeasonSessionsPerWeek);
      $("input[name=skater"+i+"_offseasonsessionsperweek]").val(skaterDetailsArr[i-1].offSeasonSessionsPerWeek);
      $("input[name=skater"+i+"_actualskatinghrs]").val(skaterDetailsArr[i-1].actualSkatingHrs +" Hours");
    }

      //Desired/Recomanded output
      $("input[name=yearsleftdesired]").val(yearsLeftToPlay + " Years");
      $("input[name=savings]").val($('#savingsdesired').text()+" "+skaterBasicInfo.costInCurrency);
      $("input[name=hourssaveddesired]").val($('#hoursSavedDesired').text()+" Hours");
      $("input[name=paybacktime]").val($('#paybacktimedesired').text() +" Months");

      //Current output
      $("input[name=yearsleftcurrent]").val(yearsLeftToPlay + " Years");
      $("input[name=savingscurrent]").val($('#savings').text()+" "+skaterBasicInfo.costInCurrency);
      $("input[name=hourssavedcurrent]").val($('#hoursSavedCurrent').text()+" Hours");
      $("input[name=paybacktimecurrent]").val($('#paybacktime').text() +" Months");

      //Recomanded Table data Comaprisions with and without sparx
      $("input[name=recommended_distance_driven_without_sparx]").val($('#recommended_distdrivenannuallywos').text());
      $("input[name=recommended_distance_driven_with_sparx]").val($('#recommended_distdrivenannuallyws').text());
      $("input[name=recommended_distance_driven_without_sparx_lifetime]").val($('#recommended_totaldistdrivenwos').text());
      $("input[name=recommended_distance_driven_with_sparx_lifetime]").val($('#recommended_totaldistdrivenws').text());

      $("input[name=recommended_time_spent_without_sparx]").val($('#recommended_timespentwos').text());
      $("input[name=recommended_time_spent_with_sparx]").val($('#recommended_timespentws').text());
      $("input[name=recommended_time_spent_without_sparx_lifetime]").val($('#recommended_totaltimespentwos').text());
      $("input[name=recommended_time_spent_with_sparx_lifetime]").val($('#recommended_totaltimespentws').text());

      $("input[name=recommended_sharpening_cost_without_sparx]").val($('#recommended_sharpeningcostannuallywos').text());
      $("input[name=recommended_sharpening_cost_with_sparx]").val($('#recommended_sharpeningcostannuallyws').text());
      $("input[name=recommended_sharpening_cost_without_sparx_lifetime]").val($('#recommended_totalsharpeningcostwos').text());
      $("input[name=recommended_sharpening_cost_with_sparx_lifetime]").val($('#recommended_totalsharpeningcostws').text());

      $("input[name=recommended_equipment_cost_without_sparx_lifetime]").val($('#recommended_totalequipmentcostwos').text());
      $("input[name=recommended_equipment_cost_with_sparx_lifetime]").val($('#recommended_totalequipmentcostws').text());

      $("input[name=recommended_total_cost_without_sparx_lifetime]").val($('#recommended_totalcostwos').text());
      $("input[name=recommended_total_cost_with_sparx_lifetime]").val($('#recommended_totalcostws').text());



      //Current Table data Comaprisions with and without sparx
      $("input[name=current_distance_driven_without_sparx_annually]").val($('#distdrivenannuallywos').text());
      $("input[name=current_distance_driven_with_sparx_annually]").val($('#distdrivenannuallyws').text());
      $("input[name=current_distance_driven_without_sparx_lifetime]").val($('#totaldistdrivenwos').text());
      $("input[name=current_distance_driven_with_sparx_lifetime]").val($('#totaldistdrivenws').text());

      $("input[name=current_time_spent_without_sparx_annually]").val($('#timespentwos').text());
      $("input[name=current_time_spent_with_sparx_annually]").val($('#timespentws').text());
      $("input[name=current_time_spent_without_sparx_lifetime]").val($('#totaltimespentwos').text());
      $("input[name=current_time_spent_with_sparx_lifetime]").val($('#totaltimespentws').text());

      $("input[name=current_sharpening_cost_without_sparx_annually]").val($('#sharpeningcostannuallywos').text());
      $("input[name=current_sharpening_cost_with_sparx_annually]").val($('#sharpeningcostannuallyws').text());
      $("input[name=current_sharpening_cost_without_sparx_lifetime]").val($('#totalsharpeningcostwos').text());
      $("input[name=current_sharpening_cost_with_sparx_lifetime]").val($('#totalsharpeningcostws').text());

      $("input[name=current_equipment_cost_without_sparx_lifetime]").val($('#totalequipmentcostwos').text());
      $("input[name=current_equipment_cost_with_sparx_lifetime]").val($('#totalequipmentcostws').text());

      $("input[name=current_total_cost_without_sparx_lifetime]").val($('#totalcostwos').text());
      $("input[name=current_total_cost_with_sparx_lifetime]").val($('#totalcostws').text());


    $('#hsForm_4fc7c541-d088-4193-badc-e8e77119619c').submit();
  }


    function showReportData() {
        var x1 = 1;//year
        var x2 = 2;//year
        var y1 = withSparxCostDetails.annualSharpeningCostCurrent * x1;
        var y2 = withSparxCostDetails.annualSharpeningCostCurrent * x2;
        var slopeWithSparx = (y2 - y1) / (x2 - x1);
        var interceptWithSparx = sharpenerUnitCost;

        y1 = withOutSparxCostDetails.annualSharpeningCostCurrent * x1;
        y2 = withOutSparxCostDetails.annualSharpeningCostCurrent * x2;
        var slopeWithoutSparx = (y2 - y1) / (x2 - x1);
        var interceptWithOutSparx = 0;

        var x_intercept = (interceptWithSparx - interceptWithOutSparx) / (slopeWithoutSparx - slopeWithSparx);


        //desired
        y1 = withSparxCostDetails.annualSharpeningCostDesired * x1;
        y2 = withSparxCostDetails.annualSharpeningCostDesired * x2;
        var desiredSlopeWithSparx = (y2 - y1) / (x2 - x1);
        var desiredInterceptWithSparx = sharpenerUnitCost;

        y1 = withOutSparxCostDetails.annualSharpeningCostDesired * x1;
        y2 = withOutSparxCostDetails.annualSharpeningCostDesired * x2;
        var desiredSlopeWithoutSparx = (y2 - y1) / (x2 - x1);
        var desiredInterceptWithOutSparxDesired = 0;

        var x_interceptDesired = (desiredInterceptWithSparx - desiredInterceptWithOutSparxDesired) / (desiredSlopeWithoutSparx - desiredSlopeWithSparx);
        var y_interceptDesired = (slopeWithoutSparx * x_intercept) + interceptWithOutSparx;//y=mx+c


        //without sparx
        var noOfSkatingSessionsPerYear = totalSkatingSessionsAttended * 12;
        var noOfSharpeningsPerYear = withOutSparxCostDetails.totalSharpeningsCountCurrent;
        var noOfMilesDriverPerYear = withOutSparxCostDetails.totalMilesDrivenCurrent;
        var noOfWaitingHoursPerYear = withOutSparxCostDetails.totalWaitingTimeCurrent;
        var totalSharpeningCostPerYear = withOutSparxCostDetails.annualSharpeningCostCurrent;


        //With sparx
        var withSparxTotalTimeSpendPerYear = withSparxCostDetails.totalSharpeningTimeCurrent;
        var withSparxTotalCostPerYear = withSparxCostDetails.annualSharpeningCostCurrent;


        //console.log(milageCost);
        console.log(skaterBasicInfo);
        console.log(skaterDetailsArr);
        console.log(withOutSparxCostDetails);
        console.log(withSparxCostDetails);

        hideAllDescriptions();
        var payBackperiod = Math.round(x_intercept * 12);
        //console.log("Payback : " + payBackperiod);
        if (payBackperiod >= 0 && payBackperiod <= 24) {
            $('#current_desc1').css('display', 'block');
        }
        else if (payBackperiod > 24 && payBackperiod <= 48) {
            $('#current_desc2').css('display', 'block');
        }
        else if (payBackperiod > 48) {
            $('#current_desc3').css('display', 'block');
        }


        payBackperiod = Math.round(x_interceptDesired * 12);
        //console.log("Payback : " + payBackperiod);
        if (payBackperiod >= 0 && payBackperiod <= 24) {
            $('#desired_desc1').css('display', 'block');
        }
        else if (payBackperiod > 24 && payBackperiod <= 48) {
            $('#desired_desc2').css('display', 'block');
        }
        else if (payBackperiod > 48) {
            $('#desired_desc3').css('display', 'block');
        }

        //Annual current Report
        $('#distdrivenannuallywos').text(Math.round(withOutSparxCostDetails.totalMilesDrivenCurrent) + " " + skaterBasicInfo.distMeasuredIn);
        $('#distdrivenannuallyws').text("0 " + skaterBasicInfo.distMeasuredIn);

        $('#timespentwos').text(Math.round(withOutSparxCostDetails.totalWaitingTimeCurrent) + " hours");
        $('#timespentws').text(Math.round(withSparxCostDetails.totalSharpeningTimeCurrent) + " hours");

        $('#sharpeningcostannuallywos').text((Math.round(withOutSparxCostDetails.annualSharpeningCostCurrent).toLocaleString("en-us")) + " " + skaterBasicInfo.costInCurrency);
        $('#sharpeningcostannuallyws').text((Math.round(withSparxCostDetails.annualSharpeningCostCurrent)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);


        //LifeTime current Report
        $('#totaldistdrivenwos').text(Math.round(withOutSparxCostDetails.totalMilesDrivenCurrent * yearsLeftToPlay) + " " + skaterBasicInfo.distMeasuredIn);
        $('#totaldistdrivenws').text("0 " + skaterBasicInfo.distMeasuredIn);

        $('#totaltimespentwos').text(Math.round(withOutSparxCostDetails.totalWaitingTimeCurrent * yearsLeftToPlay) + " hours");
        $('#totaltimespentws').text(Math.round(withSparxCostDetails.totalSharpeningTimeCurrent * yearsLeftToPlay) + " hours");

        $('#totalequipmentcostwos').text("0 " + " " + skaterBasicInfo.costInCurrency);
        $('#totalequipmentcostws').text((sharpenerUnitCost).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);

        $('#totalsharpeningcostwos').text((Math.round(withOutSparxCostDetails.annualSharpeningCostCurrent * yearsLeftToPlay)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);
        $('#totalsharpeningcostws').text((Math.round(withSparxCostDetails.annualSharpeningCostCurrent * yearsLeftToPlay)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);

        //total current
        $('#totalcostwos').text((Math.round((withOutSparxCostDetails.annualSharpeningCostCurrent * yearsLeftToPlay))).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);
        $('#totalcostws').text((Math.round((withSparxCostDetails.annualSharpeningCostCurrent * yearsLeftToPlay) + sharpenerUnitCost)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);



        //Overall Current
        $('#yearsleftcurrent').text(yearsLeftToPlay);
        $('#savings').text((Math.round((totalSharpeningCostPerYear * yearsLeftToPlay) - ((withSparxTotalCostPerYear * yearsLeftToPlay) + sharpenerUnitCost))).toLocaleString("en-us"));
        $('#hoursSavedCurrent').text(Math.round((noOfWaitingHoursPerYear - withSparxTotalTimeSpendPerYear) * yearsLeftToPlay));
        $('#paybacktime').text(Math.round(x_intercept * 12));


        //----------------------------------------End OF Recommended Report ---------------------------------------------------------------

        //Annual recommended Report
        $('#recommended_distdrivenannuallywos').text(Math.round(withOutSparxCostDetails.totalMilesDrivenDesired) + " " + skaterBasicInfo.distMeasuredIn);
        $('#recommended_distdrivenannuallyws').text("0 " + skaterBasicInfo.distMeasuredIn);

        $('#recommended_timespentwos').text(Math.round(withOutSparxCostDetails.totalWaitingTimeDesired) + " hours");
        $('#recommended_timespentws').text(Math.round(withSparxCostDetails.totalSharpeningTimeDesired) + " hours");

        $('#recommended_sharpeningcostannuallywos').text((Math.round(withOutSparxCostDetails.annualSharpeningCostDesired).toLocaleString("en-us")) + " " + skaterBasicInfo.costInCurrency);
        $('#recommended_sharpeningcostannuallyws').text((Math.round(withSparxCostDetails.annualSharpeningCostDesired)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);


        //LifeTime recommended Report
        $('#recommended_totaldistdrivenwos').text(Math.round(withOutSparxCostDetails.totalMilesDrivenDesired * yearsLeftToPlay) + " " + skaterBasicInfo.distMeasuredIn);
        $('#recommended_totaldistdrivenws').text("0 " + skaterBasicInfo.distMeasuredIn);

        $('#recommended_totaltimespentwos').text(Math.round(withOutSparxCostDetails.totalWaitingTimeDesired * yearsLeftToPlay) + " hours");
        $('#recommended_totaltimespentws').text(Math.round(withSparxCostDetails.totalSharpeningTimeDesired * yearsLeftToPlay) + " hours");

        $('#recommended_totalequipmentcostwos').text("0 " + " " + skaterBasicInfo.costInCurrency);
        $('#recommended_totalequipmentcostws').text((sharpenerUnitCost).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);

        $('#recommended_totalsharpeningcostwos').text((Math.round(withOutSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);
        $('#recommended_totalsharpeningcostws').text((Math.round(withSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);

        //total recommended
        $('#recommended_totalcostwos').text((Math.round((withOutSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay))).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);
        $('#recommended_totalcostws').text((Math.round((withSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay) + sharpenerUnitCost)).toLocaleString("en-us") + " " + skaterBasicInfo.costInCurrency);


        //Overall Recommended
        $('#yearsleftdesired').text(yearsLeftToPlay);
        $('#savingsdesired').text((Math.round((withOutSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay) - ((withSparxCostDetails.annualSharpeningCostDesired * yearsLeftToPlay) + sharpenerUnitCost))).toLocaleString("en-us"));
        $('#hoursSavedDesired').text(Math.round((withOutSparxCostDetails.totalWaitingTimeDesired - withSparxCostDetails.totalSharpeningTimeDesired) * yearsLeftToPlay));
        $('#paybacktimedesired').text(Math.round(x_interceptDesired * 12));


    }

    function GetUserInputString() {

        userInputString = skaterBasicInfo.country + ", " + skaterBasicInfo.sharpenerShopDist + ", " + skaterBasicInfo.travelTime + ", " + skaterBasicInfo.waitingTime + ", " + skaterBasicInfo.sharpeningCost + ", " + skaterBasicInfo.totalSkaterCount + ", " + skaterBasicInfo.sharpeningTime + "%, " + skaterBasicInfo.yearsLeftToPlay + ", " + skaterBasicInfo.considerTimeAsCost + ", " + skaterBasicInfo.timeCost;

        skaterDetailsArr.forEach(function (skaterObj) {
            userInputString += ", " + skaterObj.name + ", " + skaterObj.inSeasonSessionsPerWeek + ", " + skaterObj.offSeasonSessionsPerWeek + ", " + skaterObj.actualSkatingHrs;
        });
        console.log(userInputString);
        $('.userinputData').text("(" + userInputString + ")");

    }

    function CombineAllSkaterCost() {
        withOutSparxCostDetails.totalSharpeningsCountCurrent = 0;
        withOutSparxCostDetails.totalSharpeningsCountDesired = 0;
        withOutSparxCostDetails.totalSharpeningsCountRecommended = 0;
        totalSkatingSessionsAttended = 0;
        skaternames = "";

        skaterDetailsArr.forEach(function (skaterObj, index) {
            //console.log(skaterObj);
            withOutSparxCostDetails.totalSharpeningsCountCurrent += skaterObj.currentSharpenings;
            withOutSparxCostDetails.totalSharpeningsCountDesired += skaterObj.desiredSharpenings;
            withOutSparxCostDetails.totalSharpeningsCountRecommended += skaterObj.recommendedSharpenings;

            totalSkatingSessionsAttended += skaterObj.avgSessionsPerMonth;
            if (index == 0) {
                skaternames = skaterObj.name;
            }
            else if (index == totalSkaterCount) {
                skaternames += " and " + skaterObj.name;
            }
            else {
                skaternames += ", " + skaterObj.name;
            }

        });




        if (skaterBasicInfo.sharpingTripDetails == "same") {
            withOutSparxCostDetails.totalMilesDrivenCurrent = Math.round(Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.currentSharpenings; })) * (adjusteddistance * 2));
            withOutSparxCostDetails.totalMilesDrivenDesired = Math.round(Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.desiredSharpenings; })) * (skaterBasicInfo.sharpenerShopDist * 2));
            withOutSparxCostDetails.totalMilesDrivenRecommended = Math.round(Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.recommendedSharpenings; })) * (skaterBasicInfo.sharpenerShopDist * 2));



            withOutSparxCostDetails.totalWaitingTimeCurrent = Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.currentSharpenings; })) * ((adjustedTravellingTime * 2) + adjustedWaitingTime) / 60;
            withOutSparxCostDetails.totalWaitingTimeDesired = Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.desiredSharpenings; })) * ((adjustedTravellingTime * 2) + adjustedWaitingTime) / 60;
            withOutSparxCostDetails.totalWaitingTimeRecommended = Math.max.apply(Math, skaterDetailsArr.map(function (o) { return o.recommendedSharpenings; })) * ((adjustedTravellingTime * 2) + adjustedWaitingTime) / 60;
        }
        else {
            withOutSparxCostDetails.totalMilesDrivenCurrent = withOutSparxCostDetails.totalSharpeningsCountCurrent * (adjusteddistance * 2);
            withOutSparxCostDetails.totalMilesDrivenDesired = withOutSparxCostDetails.totalSharpeningsCountDesired * (skaterBasicInfo.sharpenerShopDist * 2);
            withOutSparxCostDetails.totalMilesDrivenRecommended = withOutSparxCostDetails.totalSharpeningsCountRecommended * (skaterBasicInfo.sharpenerShopDist * 2);

            withOutSparxCostDetails.totalWaitingTimeCurrent = withOutSparxCostDetails.totalSharpeningsCountCurrent * ((adjustedTravellingTime * 2) + (adjustedWaitingTime / totalSkaterCount)) / 60;
            withOutSparxCostDetails.totalWaitingTimeDesired = withOutSparxCostDetails.totalSharpeningsCountDesired * ((adjustedTravellingTime * 2) + (adjustedWaitingTime / totalSkaterCount)) / 60;
            withOutSparxCostDetails.totalWaitingTimeRecommended = withOutSparxCostDetails.totalSharpeningsCountRecommended * ((adjustedTravellingTime * 2) + (adjustedWaitingTime / totalSkaterCount)) / 60;
        }


        withOutSparxCostDetails.annualSharpeningCostCurrent = (withOutSparxCostDetails.totalSharpeningsCountCurrent * skaterBasicInfo.sharpeningCost) + (withOutSparxCostDetails.totalMilesDrivenCurrent * milageCost) + (withOutSparxCostDetails.totalWaitingTimeCurrent * skaterBasicInfo.timeCost);

        withOutSparxCostDetails.annualSharpeningCostDesired = (withOutSparxCostDetails.totalSharpeningsCountDesired * skaterBasicInfo.sharpeningCost) + (withOutSparxCostDetails.totalMilesDrivenDesired * milageCost) + (withOutSparxCostDetails.totalWaitingTimeDesired * skaterBasicInfo.timeCost);

        withOutSparxCostDetails.annualSharpeningCostRecommended = (withOutSparxCostDetails.totalSharpeningsCountRecommended * skaterBasicInfo.sharpeningCost) + (withOutSparxCostDetails.totalMilesDrivenRecommended * milageCost) + (withOutSparxCostDetails.totalWaitingTimeRecommended * skaterBasicInfo.timeCost);

    };


    function initalizeWithSparxCostDetails() {
        withSparxCostDetails.totalSharpeningsCountCurrent = withOutSparxCostDetails.totalSharpeningsCountCurrent;
        withSparxCostDetails.totalSharpeningsCountDesired = withOutSparxCostDetails.totalSharpeningsCountDesired;
        withSparxCostDetails.totalSharpeningsCountAnticipated = withOutSparxCostDetails.totalSharpeningsCountRecommended;

        withSparxCostDetails.totalGrindingRingsCurrent = withSparxCostDetails.totalSharpeningsCountCurrent / noOfSharpeningsPerRing;
        withSparxCostDetails.totalGrindingRingsDesired = withSparxCostDetails.totalSharpeningsCountDesired / noOfSharpeningsPerRing;
        withSparxCostDetails.totalGrindingRingsAnticipated = withSparxCostDetails.totalSharpeningsCountAnticipated / noOfSharpeningsPerRing;

        withSparxCostDetails.totalSharpeningTimeCurrent = withSparxCostDetails.totalSharpeningsCountCurrent * (timeTosharpenSkates / 60);
        withSparxCostDetails.totalSharpeningTimeDesired = withSparxCostDetails.totalSharpeningsCountDesired * (timeTosharpenSkates / 60);
        withSparxCostDetails.totalSharpeningTimeAnticipated = withSparxCostDetails.totalSharpeningsCountAnticipated * (timeTosharpenSkates / 60);

        withSparxCostDetails.annualSharpeningCostCurrent = (withSparxCostDetails.totalGrindingRingsCurrent * grindingWheelCost) + (withSparxCostDetails.totalSharpeningTimeCurrent * skaterBasicInfo.timeCost);
        withSparxCostDetails.annualSharpeningCostDesired = (withSparxCostDetails.totalGrindingRingsDesired * grindingWheelCost) + (withSparxCostDetails.totalSharpeningTimeDesired * skaterBasicInfo.timeCost);
        withSparxCostDetails.annualSharpeningCostAnticipated = (withSparxCostDetails.totalGrindingRingsAnticipated * grindingWheelCost) + (withSparxCostDetails.totalSharpeningTimeAnticipated * skaterBasicInfo.timeCost);

    };


    function hideAllDescriptions() {
        $('#current_desc1').css('display', 'none');
        $('#current_desc2').css('display', 'none');
        $('#current_desc3').css('display', 'none');

        $('#desired_desc1').css('display', 'none');
        $('#desired_desc2').css('display', 'none');
        $('#desired_desc3').css('display', 'none');
    }


    var isPlotted = false;
    var isPlottedDesired = false;
    var k = 1;
    var k1 = 0;

    function placeMarker(dataTable) {
        if (isPlotted) {
            var cli = this.getChartLayoutInterface();
            var chartArea = cli.getChartAreaBoundingBox();
            document.querySelector('.overlay-marker').style.display = "block";
            document.querySelector('.overlay-marker').style.top = Math.floor(cli.getYLocation(dataTable.getValue(k - 1, 1))) - 12 + "px";
            document.querySelector('.overlay-marker').style.left = Math.floor(cli.getXLocation(dataTable.getValue(k - 1, 0))) - 10 + "px";


            $(".inline-legend svg").css("width", "340px");
            $(".inline-legend").css("width", "340px");
            $(".block-legend svg").css("height", "72px");

        }
        else {
            document.querySelector('.overlay-marker').style.display = "none";

            $(".inline-legend svg").css("width", "215px");
            $(".inline-legend").css("width", "215px");
            $(".block-legend svg").css("height", "42px");

        }
    };

    function placeMarkerDesired(dataTable) {
        if (isPlottedDesired) {
            var cli = this.getChartLayoutInterface();
            var chartArea = cli.getChartAreaBoundingBox();

            document.querySelector('.overlay-marker-desired').style.display = "block";
            document.querySelector('.overlay-marker-desired').style.top = Math.floor(cli.getYLocation(dataTable.getValue(k1 - 1, 1))) - 12 + "px";
            document.querySelector('.overlay-marker-desired').style.left = Math.floor(cli.getXLocation(dataTable.getValue(k1 - 1, 0))) - 10 + "px";



            $(".inline-legend svg").css("width", "340px");
            $(".inline-legend").css("width", "340px");
            $(".block-legend svg").css("height", "72px");

        }
        else {
            document.querySelector('.overlay-marker-desired').style.display = "none";

            $(".inline-legend svg").css("width", "215px");
            $(".inline-legend").css("width", "215px");
            $(".block-legend svg").css("height", "42px");


        }
    };


    var currentResultsData;
    var currentResultsGraphOptions = {};

    var desiredResultsData;
    var desiredResultsGraphOptions = {};


    function drawTrendlines() {

        var years_pointsArray = new Array();

        currentResultsData = new google.visualization.DataTable();


        currentResultsData.addColumn('number', 'Initial Value');
        currentResultsData.addColumn('number', 'SPARX');
        currentResultsData.addColumn('number', 'WITHOUT SPARX');
        currentResultsData.addColumn({ 'type': 'string', 'role': 'style' });



        //Added

        var tempItr = yearsLeftToPlay;
        var slopeDiff = withOutSparxCostDetails.annualSharpeningCostCurrent - withSparxCostDetails.annualSharpeningCostCurrent;
        isPlotted = false;
        if (slopeDiff == 0) {
            interX = -1;
        }
        else {
            var interX = sharpenerUnitCost / (slopeDiff);
            var interY = withOutSparxCostDetails.annualSharpeningCostCurrent * interX;
        }
        k = 0;
        for (var i = 1; i <= tempItr ; i++) {
            console.log(((withSparxCostDetails.annualSharpeningCostCurrent * i) + sharpenerUnitCost) + " , " + (withOutSparxCostDetails.annualSharpeningCostCurrent * i));
            if (!isPlotted) {
                if (i - 1 < interX && interX < i) {
                    k = i;
                    currentResultsData.addRow([interX, interY, interY, null]);
                    isPlotted = true;
                }
            }
            currentResultsData.addRow([i, (withSparxCostDetails.annualSharpeningCostCurrent * i) + sharpenerUnitCost, withOutSparxCostDetails.annualSharpeningCostCurrent * i, null]);
            years_pointsArray.push(i);
        }



        var chartWidth = '100%';
        var screenWidth = $(document).width();


        if (screenWidth <= 350) {
            chartWidth = screenWidth / 1.7;
        }


        currentResultsGraphOptions = {
            'width': chartWidth,
            'height': 400,
            'vAxis': {
                title: 'DOLLARS',
                titleTextStyle: { italic: false }
            },
            'hAxis': {
                title: 'YEARS',
                titleTextStyle: { italic: false },
                textStyle: { color: '#646464' },
                ticks: years_pointsArray

            },
            series: {
                0: { color: '#f7403a', pointSize: 5, pointShape: 'square' },
                1: { color: '#000', pointSize: 5, pointShape: 'diamond' },
            },
            'legend': { position: 'none' }
        };



        var chart = new google.visualization.LineChart(document.getElementById('currentResultsChart'));
        google.visualization.events.addListener(chart, 'ready', placeMarker.bind(chart, currentResultsData));
        chart.draw(currentResultsData, currentResultsGraphOptions);

        desiredResultsData = new google.visualization.DataTable();
        desiredResultsData.addColumn('number', 'Initial Value');
        desiredResultsData.addColumn('number', 'SPARX');
        desiredResultsData.addColumn('number', 'WITHOUT SPARX');
        desiredResultsData.addColumn({ 'type': 'string', 'role': 'style' });



        var slopeDiffDesired = withOutSparxCostDetails.annualSharpeningCostDesired - withSparxCostDetails.annualSharpeningCostDesired;
        isPlottedDesired = false;
        if (slopeDiffDesired == 0) {
            interXDesired = -1;
        }
        else {
            var interXDesired = sharpenerUnitCost / (slopeDiffDesired);
            var interYDesired = withOutSparxCostDetails.annualSharpeningCostDesired * interXDesired;
        }
        k1 = 1;
        for (var i = 1; i <= tempItr ; i++) {

            if (!isPlottedDesired) {
                if (i - 1 < interXDesired && interXDesired < i) {
                    k1 = i;
                    desiredResultsData.addRow([interXDesired, interYDesired, interYDesired, null]);
                    isPlottedDesired = true;
                }
            }
            desiredResultsData.addRow([i, (withSparxCostDetails.annualSharpeningCostDesired * i) + sharpenerUnitCost, withOutSparxCostDetails.annualSharpeningCostDesired * i, null]);

        }



        desiredResultsGraphOptions = {
            'width': chartWidth,
            'height': 400,
            'vAxis': {
                title: 'DOLLARS',
                titleTextStyle: { italic: false }
            },
            'hAxis': {
                title: 'YEARS',
                titleTextStyle: { italic: false },
                textStyle: { color: '#646464' },
                ticks: years_pointsArray
            },
            series: {
                0: { color: '#f7403a', pointSize: 5, pointShape: 'square' },
                1: { color: '#000', pointSize: 5, pointShape: 'diamond' },
            },
            'legend': { position: 'none' }
        };


        var chart = new google.visualization.LineChart(document.getElementById('desiredResultsChart'));
        google.visualization.events.addListener(chart, 'ready', placeMarkerDesired.bind(chart, desiredResultsData));
        chart.draw(desiredResultsData, desiredResultsGraphOptions);

        setLeftNavHeight($('.calculator-main').height());
        graphDrawn = true;
    }


    function getStyle(el, styleProp) {
        var camelize = function (str) {
            return str.replace(/\-(\w)/g, function (str, letter) {
                return letter.toUpperCase();
            });
        };

        if (el.currentStyle) {
            return el.currentStyle[camelize(styleProp)];
        } else if (document.defaultView && document.defaultView.getComputedStyle) {
            return document.defaultView.getComputedStyle(el, null)
                                       .getPropertyValue(styleProp);
        } else {
            return el.style[camelize(styleProp)];
        }
    }


    //http://stackoverflow.com/questions/34042440/using-html2canvas-to-render-a-highcharts-chart-to-pdf-doesnt-work-on-ie-and-fir

    //As canvas2html unable to read svg tag, we are converting svg tag to canvas tag using this function
    function convertSvgToCanvas() {
        var svgElements = $("#paybackCalculation").find('svg');

        //replace all svgs with a temp canvas
        svgElements.each(function () {
            var canvas, xml;

            // canvg doesn't cope very well with em font sizes so find the calculated size in pixels and replace it in the element.
            $.each($(this).find('[style*=em]'), function (index, el) {
                $(this).css('font-size', getStyle(el, 'font-size'));
            });

            canvas = document.createElement("canvas");
            canvas.className = "screenShotTempCanvas";
            //convert SVG into a XML string
            xml = (new XMLSerializer()).serializeToString(this);

            // Removing the name space as IE throws an error
            xml = xml.replace(/xmlns=\"http:\/\/www\.w3\.org\/2000\/svg\"/, '');

            //draw the SVG onto a canvas
            canvg(canvas, xml);
            $(canvas).insertAfter(this);
            //hide the SVG element
              $(this).attr('class', 'tempHide');
              $(this).hide();
        });
    }

    $(".emailPopUp").click(function () {
        $('#email').val("");
        $('#submitEmail').prop("disabled", false);
        $('#submitEmail').css("background-color", "grey");
        $("#myModal").css("display", "block");
    });

    $('.close').click(function () {
        $('#myModal').css("display", "none");

    });

    // convert particular div to image
    function convertDivToImage(divID) {

        console.log(divID);

      if (emailFlag && divID == 'paybackCalculation') {
          convertSvgToCanvas();
          console.log("Converting paybackCalculation div");
            emailFlag = false;
            $('.hrline').css("opacity", "1");
        }

        html2canvas(document.getElementById(divID), {
            onrendered: function (canvas) {

                var imgdata = canvas.toDataURL("image/png");

                if (divID == 'primaryInfo') {
                    console.log("1");
                    primaryInfoImage = imgdata.split(',')[1];
                }
                else if (divID == 'skaterinfo') {
                    console.log("2");
                    skaterinfoImage = imgdata.split(',')[1];
                  	convertDivToImage("paybackCalculation");
                }
                else if (divID == 'paybackCalculation') {
                    console.log(document.getElementById(divID));
                    console.log("3");
                    finalReportImage = imgdata.split(',')[1];


                  $("#primaryInfo").show();
                   $("#skaterinfo").show();
                    for(var i = 1; i<=totalSkaterCount;i++){
                        $("#skaterinfo"+i).show();
                        $("#content"+i).show();
                    }

                  convertDivToImage("totalpage");

                    //After filling of both HouseHoldInfo and SkaterInfo we are sending the mail
                    //sendUserInputInEmail();
                }
              else if (divID == 'totalpage'){
                console.log("4");
                completeImage = imgdata.split(',')[1];

                $("#primaryInfo").hide();
                $("#skaterinfo").hide();
                for(var i = 1; i<=totalSkaterCount;i++){
                    $("#skaterinfo"+i).hide();
                    $("#content"+i).hide();
                }

                sendUserInputInEmail();
              }
            }
        });

    }

    function sendUserInputInEmail() {
        console.log("sending user info in mail");


        //var emailID = "colleen@sparxhockey.com";

        $.ajax({
            type: "POST",
            url: "https://mandrillapp.com/api/1.0/messages/send.json",
            data: {
                'key': '0EwG1MMQRARK2oEqetHCIw',
                'message': {
                    'from_email': 'payback@sparxhockey.com',
                    'to': [
                        {
                            'email': sparx_emailID,
                            'name': sparx_emailID,
                            'type': 'to'
                        }
                    ],
                    'autotext': 'true',
                    'html': 'text',
                    'attachments': [
                          {
                              "type": "image/jpeg",
                              "name": "PayBackCalculater.jpg",
                              "content": completeImage
                          }
                    ]
                }
            }
        }).done(function (response) {
            console.log(response); // if you're into that sorta thing
        });
      console.log("Sending user input in mail");
    }

    $(window).scroll(function () {
      if($(".header-calculator").offset()!= null && $(".featured-lead").offset()!= null){

        console.log($(".header-calculator").offset());
        if (($(window).scrollTop() > $(".header-calculator").offset().top + 280) && ($(window).scrollTop() <= $(".featured-lead").offset().top) + 10) {
            $(".breadcrumb").css("position", "fixed");
            $(".breadcrumb").css("top", "0");
        }

        if ($(window).scrollTop() <= $(".header-calculator").offset().top + 280) {
            $(".breadcrumb").css("position", "relative");
        }

        if ($(window).scrollTop() > $(".featured-lead").offset().top + 20) {
            $(".breadcrumb").css("position", "relative");
            $(".breadcrumb").css("top", $(".featured-lead").offset().top - $(".header-calculator").offset().top - 350);
        }

        if (($(window).scrollTop() > $("#mySidenav").offset().top - 100) && ($(window).scrollTop() <= $(".featured-lead").offset().top - 534.859375)) {
            $(".left-nav").css("position", "fixed");
            $(".left-nav").css("top", "134.859375px");
            $(".left-nav").addClass("left-navwhenfix");
        }

        if ($(window).scrollTop() <= $("#mySidenav").offset().top - 100) {
            $(".left-nav").css("position", "static");
            $(".left-nav").removeClass("left-navwhenfix");
        }

        if ($(window).scrollTop() > $(".featured-lead").offset().top - 634.859375) {
            $(".left-nav").css("position", "relative");
            $(".left-nav").css("top", $(".featured-lead").offset().top - 934.859375);
            $(".left-nav").removeClass("left-navwhenfix");
        }
      }

    });
    //end
    //console.log("END");


    //-------------------------------- Commercial Calculator specific jquery -------------------------------------------------------

    var skaterShopBasicInfo = new Object();

    //Manual Sharpening Cost Assumption Object
    var manulaSharpeningDetailsObj = new Object();

    //Manual Sharpening Cost Assumption Object
    var sparxSharpeningDetailsObj = new Object();

    //manula sharpening variables
    var manual_noOfSharpeningsPerMonth;
    var manual_sharpeningRevenue;
    var manual_sharpenerCost;
    var manual_sharpeningCost;
    var manual_monthlyProfit;

    //Sparx sharpening variables
    var sparx_noOfSharpeningsPerMonth;
    var sparx_sharpeningRevenue;
    var sparx_sharpenerCost;
    var sparx_sharpeningCost;
    var sparx_monthlyProfit;


    $("div.countrybtn_commercial").find("input[type='button']").click(function () {
        $(".countrybtn_commercial").find("input[type='button']").css("background-color", "#efefef");
        $(".countrybtn_commercial").find("input[type='button']").css("color", "rgba(0, 0, 0, 0.5)");
        $(".countrybtn_commercial").find("input[type='button']").css("border", "solid 0.5px #aaaaaa");

        countryButtonClicked(this);

        ShopInfoValidat();
    });

    $('#continue_commercial').click(function () {
        console.log("Continue Button Clicked...");
        if (country === "CANADA") {
            sharpenerUnitCost = Math.round(sharpenerUnitCost * conversionFactor);
            grindingWheelCost = Math.round(grindingWheelCost * conversionFactor);
        }

        //Basic Skater Shop Info
        skaterShopBasicInfo.shop_costInCurrency = $("input[name='currency']:checked").val();
        skaterShopBasicInfo.shop_costPerSharpening = parseInt($('#shop-sharpeningcost').val());
        skaterShopBasicInfo.shop_sharpeningCountPerYear = parseInt($('#current-sharpenings-count').val());
        skaterShopBasicInfo.shop_percentageIncreaseInSharpenings = parseInt($('#percentage-increase').val());;
        skaterShopBasicInfo.shop_includeExistingEquipmentCost = $("input[name='consider-equipment-cost']:checked").val();
        skaterShopBasicInfo.shop_timeSpanForAnalysis = parseInt($('#analysis-years').val());
        skaterShopBasicInfo.shop_totalSharpeningCountPerYear = skaterShopBasicInfo.shop_sharpeningCountPerYear * (1 + skaterShopBasicInfo.shop_percentageIncreaseInSharpenings / 100);

        //Manual Sharpening Cost Assumption Info
        //manulaSharpeningDetailsObj.sharpenerUnitCost = parseInt($('#equipment-cost').val()) == NaN ? 0 : parseInt($('#equipment-cost').val());
        manulaSharpeningDetailsObj.sharpenerUnitCost = parseInt($('#equipment-cost').val());
        manulaSharpeningDetailsObj.grindingWheelCost = 30;//?
        manulaSharpeningDetailsObj.sharpeningsPerWheel = 250;//?
        manulaSharpeningDetailsObj.materialCostPerSharpening = Math.round(manulaSharpeningDetailsObj.grindingWheelCost / manulaSharpeningDetailsObj.sharpeningsPerWheel * 100) / 100;//?
        //manulaSharpeningDetailsObj.operatorWagePerHour = parseInt($('#current-hourly-wage').val());
        manulaSharpeningDetailsObj.operatorWagePerHour = $('#current-hourly-wage').val();
        manulaSharpeningDetailsObj.timeToSharpenSkate = minSharpeningTimePerSkate;//?
        //manulaSharpeningDetailsObj.labourCostPerPair = Math.round(((minSharpeningTimePerSkate / 60) * manulaSharpeningDetailsObj.operatorWagePerHour) * 100) / 100;
        manulaSharpeningDetailsObj.labourCostPerPair = (minSharpeningTimePerSkate / 60) * manulaSharpeningDetailsObj.operatorWagePerHour;
        manulaSharpeningDetailsObj.labourMaterialCostPerPair = manulaSharpeningDetailsObj.labourCostPerPair + manulaSharpeningDetailsObj.materialCostPerSharpening;
        manulaSharpeningDetailsObj.sharpeningsBetweenMaintenance = 10000;//?
        manulaSharpeningDetailsObj.maintenanceCostPerEvent = 0;//?
        manulaSharpeningDetailsObj.annualMaintenanceCost = 0;//?

        //Sparx Sharpening Cost Assumption Info
        sparxSharpeningDetailsObj.sharpenerUnitCost = sharpenerUnitCost;
        //sparxSharpeningDetailsObj.recommendedNoOfSharpeners = skaterShopBasicInfo.shop_sharpeningCountPerYear > 10000 ? 4 : 2;
        sparxSharpeningDetailsObj.recommendedNoOfSharpeners = 4;
        sparxSharpeningDetailsObj.grindingWheelCost = grindingWheelCost;
        sparxSharpeningDetailsObj.sharpeningsPerWheel = noOfSharpeningsPerRing;//?
        //sparxSharpeningDetailsObj.materialCostPerSharpening = Math.round(sparxSharpeningDetailsObj.grindingWheelCost / sparxSharpeningDetailsObj.sharpeningsPerWheel * 100) / 100;
        sparxSharpeningDetailsObj.materialCostPerSharpening = sparxSharpeningDetailsObj.grindingWheelCost / sparxSharpeningDetailsObj.sharpeningsPerWheel;
        // sparxSharpeningDetailsObj.operatorWagePerHour = parseInt($('#non-expert-wage').val());
        sparxSharpeningDetailsObj.operatorWagePerHour = $('#non-expert-wage').val();
        sparxSharpeningDetailsObj.timeToSharpenSkate = Math.round(minSharpeningTimePerSkate / sparxSharpeningDetailsObj.recommendedNoOfSharpeners * 100) / 100;
        //sparxSharpeningDetailsObj.labourCostPerPair = Math.round(((sparxSharpeningDetailsObj.timeToSharpenSkate / 60) * sparxSharpeningDetailsObj.operatorWagePerHour) * 100)/100;
        sparxSharpeningDetailsObj.labourCostPerPair = (sparxSharpeningDetailsObj.timeToSharpenSkate / 60) * sparxSharpeningDetailsObj.operatorWagePerHour;
        sparxSharpeningDetailsObj.labourMaterialCostPerPair = sparxSharpeningDetailsObj.labourCostPerPair + sparxSharpeningDetailsObj.materialCostPerSharpening;
        sparxSharpeningDetailsObj.sharpeningsBetweenMaintenance = 19000;//?
        sparxSharpeningDetailsObj.maintenanceCostPerEvent = sharpenerUnitCost;//?
        sparxSharpeningDetailsObj.annualMaintenanceCost = skaterShopBasicInfo.shop_totalSharpeningCountPerYear / sparxSharpeningDetailsObj.sharpeningsBetweenMaintenance * sparxSharpeningDetailsObj.maintenanceCostPerEvent;

        $('#skater-shop-info').css("display", "none");
        $('#paybackCalculation,#benefits-details').css("display", "block");

        $('#step3').css("color", "#fff");
        $('#step1').css("color", "grey");
        $('#step3').prop("disabled", false);


        $('#item3').css("cursor", "pointer");

        $('#houseimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/completed.png?8630967100296663801');
        $('#step1').removeClass('arrow_box').addClass('leftPanelBtns');

        $('#calculateimg').attr('src', 'https://cdn.shopify.com/s/files/1/0932/7770/files/payback-current.png?8630967100296663801');
        $('#step3').removeClass('leftPanelBtns').addClass('arrow_box');

        $('#brdcrb1').removeClass('breadcrumb-active');
        $('#brdcrb3').addClass('breadcrumb-active');
        $('#brdcrb1').css("color", "#ffffff");
        $('#brdcrb1').css("cursor", "pointer");

        //display manipulation for benefits details
        $(".benefits-details").css("display", "block");
        $(window).scroll(function () {
          if($(".header-calculator").offset() != null && $(".header-calculator").offset() != undefined){
            if (($(window).scrollTop() > $(".header-calculator").offset().top + 280) && ($(window).scrollTop() <= $(".benefits-details").offset().top) + 10) {
                $(".breadcrumb").css("position", "fixed");
                $(".breadcrumb").css("top", "0");
            }

            if ($(window).scrollTop() <= $(".header-calculator").offset().top + 280) {
                $(".breadcrumb").css("position", "relative");
            }

            if ($(window).scrollTop() > $(".benefits-details").offset().top + 20) {
                $(".breadcrumb").css("position", "relative");
                $(".breadcrumb").css("top", $(".benefits-details").offset().top - $(".header-calculator").offset().top - 350);
            }

            if (($(window).scrollTop() > $("#mySidenav").offset().top - 100) && ($(window).scrollTop() <= $(".benefits-details").offset().top - 534.859375)) {
                $(".left-nav").css("position", "fixed");
                $(".left-nav").css("top", "134.859375px");
                $(".left-nav").addClass("left-navwhenfix");
            }

            if ($(window).scrollTop() <= $("#mySidenav").offset().top - 100) {
                $(".left-nav").css("position", "static");
                $(".left-nav").removeClass("left-navwhenfix");
            }

            if ($(window).scrollTop() > $(".benefits-details").offset().top - 634.859375) {
                $(".left-nav").css("position", "relative");
                $(".left-nav").css("top", $(".benefits-details").offset().top - 934.859375);
                $(".left-nav").removeClass("left-navwhenfix");
            }
          }

        });

        generateCommercialCalculatorReport();
        getUserInputDataAsSting();

        drawCommercialGraphTrendlines();
        var mainCalcSection = document.querySelector('.calculator-main');
        mainCalcSection.scrollIntoView({ behavior: 'smooth' });

        console.log("Draw graph completed");
    });

    function getUserInputDataAsSting() {
        userInputString = country + ", " + skaterBasicInfo.email + ", " + skaterShopBasicInfo.shop_costPerSharpening + ", " + skaterShopBasicInfo.shop_sharpeningCountPerYear + ", " + manulaSharpeningDetailsObj.operatorWagePerHour + ", " + sparxSharpeningDetailsObj.operatorWagePerHour + ", " + skaterShopBasicInfo.shop_percentageIncreaseInSharpenings + ", " + skaterShopBasicInfo.shop_includeExistingEquipmentCost + ", ";
        if (skaterShopBasicInfo.shop_includeExistingEquipmentCost == 'yes') {
            userInputString += manulaSharpeningDetailsObj.sharpenerUnitCost + ", ";
        }
        userInputString += skaterShopBasicInfo.shop_timeSpanForAnalysis;
        $('.userinputData_commercial').text("(" + userInputString + ")");
    }

    function generateCommercialCalculatorReport() {

        manual_noOfSharpeningsPerMonth = Math.round(skaterShopBasicInfo.shop_sharpeningCountPerYear / 12);
        manual_sharpeningRevenue = Math.round(manual_noOfSharpeningsPerMonth * skaterShopBasicInfo.shop_costPerSharpening);
        manual_sharpenerCost = skaterShopBasicInfo.shop_includeExistingEquipmentCost == "yes" ? manulaSharpeningDetailsObj.sharpenerUnitCost : 0;
        manual_sharpeningCost = Math.round(manual_noOfSharpeningsPerMonth * manulaSharpeningDetailsObj.labourMaterialCostPerPair);
        manual_monthlyProfit = Math.round(manual_sharpeningRevenue - manual_sharpeningCost);//subscract manual_sharpenerCost for the first month


        sparx_noOfSharpeningsPerMonth = Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear / 12);
        sparx_sharpeningRevenue = Math.round(sparx_noOfSharpeningsPerMonth * skaterShopBasicInfo.shop_costPerSharpening);
        sparx_sharpenerCost = skaterShopBasicInfo.shop_includeExistingEquipmentCost == "yes" ? sparxSharpeningDetailsObj.sharpenerUnitCost : 0;
        sparx_sharpeningCost = Math.round(sparx_noOfSharpeningsPerMonth * sparxSharpeningDetailsObj.labourMaterialCostPerPair);
        sparx_monthlyProfit = Math.round(sparx_sharpeningRevenue - sparx_sharpeningCost);//subscract sparx_sharpenerCost for the first month


        //grinding ring cost, labour charges,
        var sparx_consumableCostPerMonth = sparx_sharpeningCost;
        var manual_consumableCostPerMonth = manual_sharpeningCost;

        //Annual maintance cost
        var sparx_overheadCostPerYear = sparxSharpeningDetailsObj.annualMaintenanceCost;
        var manual_overheadCostPerYear = manulaSharpeningDetailsObj.annualMaintenanceCost;
        console.log(skaterShopBasicInfo);
        console.log(manulaSharpeningDetailsObj);
        console.log(sparxSharpeningDetailsObj);


        var ts_wos = (Math.round(skaterShopBasicInfo.shop_sharpeningCountPerYear / 12) * skaterShopBasicInfo.shop_timeSpanForAnalysis * 12);
        var ts_ws = (Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear / 12) * skaterShopBasicInfo.shop_timeSpanForAnalysis * 12);

        //Overall Result
        $('#timehorizon').text(skaterShopBasicInfo.shop_timeSpanForAnalysis);
        $('#addationalprofit').text(((Math.round(ts_ws * skaterShopBasicInfo.shop_costPerSharpening) - Math.round(ts_ws * sparxSharpeningDetailsObj.labourMaterialCostPerPair) - Math.round(sparxSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis)) - (Math.round(ts_wos * skaterShopBasicInfo.shop_costPerSharpening) - Math.round(ts_wos * manulaSharpeningDetailsObj.labourMaterialCostPerPair) - Math.round(manulaSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis))).toLocaleString("en-us"));
        $('#addationalsharpenings').text(Math.round((skaterShopBasicInfo.shop_totalSharpeningCountPerYear - skaterShopBasicInfo.shop_sharpeningCountPerYear) * skaterShopBasicInfo.shop_timeSpanForAnalysis).toLocaleString("en-us"));



        //Annual Report
        $('#noofsharpenings_wos').text(skaterShopBasicInfo.shop_sharpeningCountPerYear);
        $('#noofsharpenings_ws').text(skaterShopBasicInfo.shop_totalSharpeningCountPerYear);

        $('#consumablecost_wos').text(Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear * manulaSharpeningDetailsObj.materialCostPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#consumablecost_ws').text(Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear * sparxSharpeningDetailsObj.materialCostPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#overheadcost_wos').text(Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear * manulaSharpeningDetailsObj.labourCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#overheadcost_ws').text(Math.round(skaterShopBasicInfo.shop_totalSharpeningCountPerYear * sparxSharpeningDetailsObj.labourCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#totalcost_annually_wos').text(Math.round((skaterShopBasicInfo.shop_totalSharpeningCountPerYear * manulaSharpeningDetailsObj.materialCostPerSharpening) + (skaterShopBasicInfo.shop_totalSharpeningCountPerYear * manulaSharpeningDetailsObj.labourCostPerPair)).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#totalcost_annually_ws').text(Math.round((skaterShopBasicInfo.shop_totalSharpeningCountPerYear * sparxSharpeningDetailsObj.materialCostPerSharpening) + (skaterShopBasicInfo.shop_totalSharpeningCountPerYear * sparxSharpeningDetailsObj.labourCostPerPair)).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);


        //Lifetime Report

        $('#totalsharpenings_wos').text(ts_wos.toLocaleString("en-us"));
        $('#totalsharpenings_ws').text(ts_ws.toLocaleString("en-us"));

        $('#equipmentcost_wos').text(manulaSharpeningDetailsObj.sharpenerUnitCost.toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#equipmentcost_ws').text(sparxSharpeningDetailsObj.sharpenerUnitCost.toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#maintenancecost_wos').text(Math.round(manulaSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#maintenancecost_ws').text(Math.round(sparxSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#lifetime_consumablecost_wos').text(Math.round(ts_wos * manulaSharpeningDetailsObj.materialCostPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#lifetime_consumablecost_ws').text(Math.round(ts_ws * sparxSharpeningDetailsObj.materialCostPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#lifetime_overheadcost_wos').text(Math.round(ts_wos * manulaSharpeningDetailsObj.labourCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#lifetime_overheadcost_ws').text(Math.round(ts_ws * sparxSharpeningDetailsObj.labourCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#totalcost_lifetime_wos').text(Math.round(ts_wos * manulaSharpeningDetailsObj.labourMaterialCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#totalcost_lifetime_ws').text(Math.round(ts_ws * sparxSharpeningDetailsObj.labourMaterialCostPerPair).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#totalrevenue_wos').text(Math.round(ts_wos * skaterShopBasicInfo.shop_costPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#totalrevenue_ws').text(Math.round(ts_ws * skaterShopBasicInfo.shop_costPerSharpening).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);

        $('#totalprofit_wos').text((Math.round(ts_wos * skaterShopBasicInfo.shop_costPerSharpening) - Math.round(ts_wos * manulaSharpeningDetailsObj.labourMaterialCostPerPair) - Math.round(manulaSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis)).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
        $('#totalprofit_ws').text((Math.round(ts_ws * skaterShopBasicInfo.shop_costPerSharpening) - Math.round(ts_ws * sparxSharpeningDetailsObj.labourMaterialCostPerPair) - Math.round(sparxSharpeningDetailsObj.annualMaintenanceCost * skaterShopBasicInfo.shop_timeSpanForAnalysis)).toLocaleString("en-us") + " " + skaterShopBasicInfo.shop_costInCurrency);
    }




    var outputResultsData = null;
    var outputResultsGraphOptions = null;
    function drawCommercialGraphTrendlines() {

        console.log("Draw graph caller");

        var years_pointsArray = new Array();
        years_pointsArray.push(0);

        outputResultsData = new google.visualization.DataTable();
        outputResultsData.addColumn('number', 'Initial Value');
        outputResultsData.addColumn('number', 'SPARX');
        outputResultsData.addColumn('number', 'WITHOUT SPARX');

        var manual_commulativeCost = manual_monthlyProfit - manual_sharpenerCost;

        var sparx_commulativeCost = sparx_monthlyProfit - sparx_sharpenerCost;

        console.log(sparxSharpeningDetailsObj);
        console.log(manulaSharpeningDetailsObj);
        console.log(skaterShopBasicInfo);

        var noOfMonths = skaterShopBasicInfo.shop_timeSpanForAnalysis * 12
        var noOfDivisions = Math.round(noOfMonths / 5);

        var noOfYearsCount = 0;
        var i = 0;

        outputResultsData.addRow([0, 0, 0]);//Values for zero year
        outputResultsData.addRow([1, sparx_commulativeCost, manual_commulativeCost]);//Values for first year

        for (i = 2; i <= noOfMonths; i++) {
            console.log(sparx_commulativeCost + "-->" + manual_commulativeCost);
            if (i % 12 == 0) {
                manual_commulativeCost += (manual_monthlyProfit - manulaSharpeningDetailsObj.annualMaintenanceCost);
                sparx_commulativeCost += (sparx_monthlyProfit - sparxSharpeningDetailsObj.annualMaintenanceCost);
            }
            else {
                manual_commulativeCost += manual_monthlyProfit;
                sparx_commulativeCost += sparx_monthlyProfit;
                //outputResultsData.addRow([i, sparx_commulativeCost, manual_commulativeCost]);
            }
            outputResultsData.addRow([i, sparx_commulativeCost, manual_commulativeCost]);

            if (i % noOfDivisions == 0) {
                years_pointsArray.push(i);
            }
        }

        //extra points need to be marked on graph
        years_pointsArray.push(years_pointsArray[years_pointsArray.length - 1] + noOfDivisions);
        years_pointsArray.push(years_pointsArray[years_pointsArray.length - 1] + noOfDivisions);

        for (i = skaterShopBasicInfo.shop_timeSpanForAnalysis * 12 + 1; i <= years_pointsArray[years_pointsArray.length - 1]; i++) {
            outputResultsData.addRow([i, 0, 0]);
        }


        var chartWidth = '100%';
        var screenWidth = $(document).width();

        if (screenWidth <= 350) {
            chartWidth = screenWidth -100;
        }

        //console.log("inital width : " + screenWidth);
        outputResultsGraphOptions = {
            'width': chartWidth,
            'height': 800,
            'vAxis': {
                title: 'DOLLARS',
                titleTextStyle: { italic: false }
            },
            'hAxis': {
                title: 'MONTHS',
                titleTextStyle: { italic: false },
                textStyle: { color: '#646464' },
                ticks: years_pointsArray

            },
            series: {
                0: { color: '#f7403a', pointSize: 5, pointShape: 'square' },
                1: { color: '#000', pointSize: 5, pointShape: 'diamond' },
            },
            'legend': { position: 'top', alignment: 'center' }
        };

        var chart = new google.visualization.LineChart(document.getElementById('CommercialCalculatorChart'));
        chart.draw(outputResultsData, outputResultsGraphOptions);

        graphDrawn_commercial = true;
        setLeftNavHeight($('.calculator-main').height());
    }


    var graphDrawn = false;
    var r = $(document).width() / 460;
    console.log("ratio " + r);
    var graphDrawn_commercial = false;
    var flag = true;
    var count = 0;
    var left = 0;
    $(window).resize(function () {

        if (graphDrawn) {
            console.log("In resize");

            var chart = new google.visualization.LineChart(document.getElementById('currentResultsChart'));
            google.visualization.events.addListener(chart, 'ready', placeMarker.bind(chart, currentResultsData));
            chart.draw(currentResultsData, currentResultsGraphOptions);

            chart = new google.visualization.LineChart(document.getElementById('desiredResultsChart'));
            google.visualization.events.addListener(chart, 'ready', placeMarkerDesired.bind(chart, desiredResultsData));
            chart.draw(desiredResultsData, desiredResultsGraphOptions);
        }

        if (graphDrawn_commercial) {
            //console.log("In resize-commercial");
            var chart = new google.visualization.LineChart(document.getElementById('CommercialCalculatorChart'));
            chart.draw(outputResultsData, outputResultsGraphOptions);
        }


        if ($(document).width() > 800) {
            setLeftNavHeight($('.calculator-main').height());
            $('.sparx-logo-desired').css("left", $(document).width() / (1903 / 460) + 20);
        }
        else {
            left = $(document).width() / (800 / 340) + 40;

            if ($(document).width() < 650 && $(document).width() > 450) {
                left += 20;
            }
            else if ($(document).width() < 400) {
                left -= 20;
            }
            $('.sparx-logo-desired').css("left", left);
        }



        //console.log("In resize" + $(document).width());
    });
    //-------------------------------- End of Commercial Calculator specific JS -----------------------------------------------------
});
